import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Input, Form, Space, Avatar } from "antd";

import { TextField } from "misc/fields";

const Title = styled(TextField)({
    fontSize: 16
});

const FormItem = ({ form, name, initialValue, icon, title, visible = true, ...props }) => {
    const [t] = useTranslation();

    useEffect(() => {
        form.setFieldValue(name, initialValue);
    }, [form, initialValue]);

    return (
        <>
            {visible && (
                <Space direction="vertical" size={20} style={{ width: "100%" }}>
                    <Space size={12}>
                        {icon && <Avatar size={40}>{icon}</Avatar>}
                        <Title value={title} />
                    </Space>
                    <Form form={form}>
                        <Form.Item name={name} {...props}>
                            {props.children}
                        </Form.Item>
                    </Form>
                </Space>
            )}
        </>
    );
};

FormItem.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.any.isRequired,
    visible: PropTypes.bool
};

export default FormItem;
